import __request__ from "routing/request";
export function allRepositories(type, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datatiering/datatiering/repositories", null, { "type": type }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function save(repository, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datatiering/datatiering/repositories", repository, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function allFsRepoPaths(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datatiering/datatiering/repositories/fs-paths", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteFailedSnapshot(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datatiering/datatiering/repositories/index_set/${id}/failed_snapshot`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function pageListRepositories(page = 1, per_page = 50, query, filters, sort = "name", order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datatiering/datatiering/repositories/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getReadinessChecks(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datatiering/datatiering/repositories/readiness", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(repository, name, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.datatiering/datatiering/repositories/${name}`, repository, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(name, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datatiering/datatiering/repositories/${name}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getCredentials(name, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datatiering/datatiering/repositories/${name}/credentials`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateCredentials(name, credentials, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.datatiering/datatiering/repositories/${name}/credentials`, credentials, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function repair(name, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.datatiering/datatiering/repositories/${name}/repair`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
